// extracted by mini-css-extract-plugin
module.exports = {"list":"list-16vIY"};